import { render } from "./TaskActivity.vue?vue&type=template&id=201c384e&scoped=true"
import script from "./TaskActivity.vue?vue&type=script&lang=js"
export * from "./TaskActivity.vue?vue&type=script&lang=js"

import "./TaskActivity.vue?vue&type=style&index=0&id=201c384e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201c384e"]])

export default __exports__